var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"easteregg",class:{ active: _vm.isActive },style:(_vm.mystyle),attrs:{"id":"teddybear"},on:{"click":_vm.activate}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"easteregg-inner"},[_c('video',{attrs:{"id":"eastereggvideo","src":require("../assets/easteregg.webm")}})])
}]

export { render, staticRenderFns }